/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

import Select from "react-select";
import * as XLSX from "xlsx"; // Import XLSX for parsing Excel files

const CsvUploadModal = () => {
  const fileInputRef = useRef(null);

  const { t } = useTranslation(); //for translation

  const token = localStorage.getItem("token"); // token

  const [fileData, setFileData] = useState(null); // Store parsed file data
  const [headers, setHeaders] = useState([]); // Store column headers
  const [mapping, setMapping] = useState({}); // Store column-to-field mapping
  const [validationError, setValidationError] = useState(""); // Store validation error message
  const [invalidFields, setInvalidFields] = useState([]); // Track invalid fields
  const [selectedRole, setSelectedRole] = useState(null); // Track selected role
  const [userModelFields, setUserModelFields] = useState({}); // Dynamically set fields based on role

  const [uploadedCompanyDataInfo, setUploadedCompanyDataInfo] = useState(null); // Store uploaded data info
  const [isLoading, setIsLoading] = useState(false); // Track loading state

  const [companyCreated, setCompanyCreated] = useState(0); // Track companies created
  const [companyUpdated, setCompanyUpdated] = useState(0); // Track companies updated
  const [accountCreated, setAccountCreated] = useState(0); // Track accounts created
  const [accountUpdated, setAccountUpdated] = useState(0); // Track accounts updated

  const roleOptions = [
    { value: "client", label: "Upload Clients & Contacts" },
    { value: "beneficiary", label: "Upload Beneficiary & Contacts" },
    { value: "educator", label: "Upload Educators" },
    { value: "user", label: "Upload Users" },
  ];

  // client and beneficiary fields
  const clientFields = {
    company: { required: true, label: "Company" },
    cif: { required: false, label: "CIF" },
    email: { required: false, label: "Company Email" },
    phone: { required: false, label: "Phone" },
    location: { required: false, label: "Address" },
    country: { required: false, label: "Country" },
    town: { required: false, label: "Town" },
    city: { required: false, label: "City" },
    zipcode: { required: false, label: "Zipcode" },
    website: { required: false, label: "Website" },
    latitude: { required: false, label: "Latitude" },
    longitude: { required: false, label: "Longitude" },
    mapurl: { required: false, label: "Map URL" },

    contact1_email: { required: false, label: "Contact 1 Email" },
    contact1_name: { required: false, label: "Contact 1 Name" },
    contact1_phone: { required: false, label: "Contact 1 Phone" },

    contact2_email: { required: false, label: "Contact 2 Email" },
    contact2_name: { required: false, label: "Contact 2 Name" },
    contact2_phone: { required: false, label: "Contact 2 Phone" },

    contact3_email: { required: false, label: "Contact 3 Email" },
    contact3_name: { required: false, label: "Contact 3 Name" },
    contact3_phone: { required: false, label: "Contact 3 Phone" },

    contact4_email: { required: false, label: "Contact 4 Email" },
    contact4_name: { required: false, label: "Contact 4 Name" },
    contact4_phone: { required: false, label: "Contact 4 Phone" },

    contact5_email: { required: false, label: "Contact 5 Email" },
    contact5_name: { required: false, label: "Contact 5 Name" },
    contact5_phone: { required: false, label: "Contact 5 Phone" },

    contact6_email: { required: false, label: "Contact 6 Email" },
    contact6_name: { required: false, label: "Contact 6 Name" },
    contact6_phone: { required: false, label: "Contact 6 Phone" },

    contact7_email: { required: false, label: "Contact 7 Email" },
    contact7_name: { required: false, label: "Contact 7 Name" },
    contact7_phone: { required: false, label: "Contact 7 Phone" },

    contact8_email: { required: false, label: "Contact 8 Email" },
    contact8_name: { required: false, label: "Contact 8 Name" },
    contact8_phone: { required: false, label: "Contact 8 Phone" },

    contact9_email: { required: false, label: "Contact 9 Email" },
    contact9_name: { required: false, label: "Contact 9 Name" },
    contact9_phone: { required: false, label: "Contact 9 Phone" },

    contact10_email: { required: false, label: "Contact 10 Email" },
    contact10_name: { required: false, label: "Contact 10 Name" },
    contact10_phone: { required: false, label: "Contact 10 Phone" },
  };

  // educator and user
  const userFields = {
    name: { required: true, label: "Name" },
    surname: { required: false, label: "Surname" },
    email: { required: true, label: "Email" },
    phone: { required: false, label: "Phone" },
    company: { required: true, label: "Company" },
    location: { required: false, label: "Address" },
    country: { required: false, label: "Country" },
    town: { required: false, label: "Town" },
    city: { required: false, label: "City" },
    zipcode: { required: false, label: "Zipcode" },
    website: { required: false, label: "Website" },
    latitude: { required: false, label: "Latitude" },
    longitude: { required: false, label: "Longitude" },
    mapurl: { required: false, label: "Map URL" },
    costperhour: { required: false, label: "Cost per hour" },
  };

  const handleRoleChange = (selectedOption) => {
    setSelectedRole(selectedOption);
    switch (selectedOption.value) {
      case "client":
        setUserModelFields(clientFields);
        break;
      case "beneficiary":
        setUserModelFields(clientFields);
        break;
      default:
        setUserModelFields(userFields);
        break;
    }
  };

  const handleFileUpload = (event) => {
    setUploadedCompanyDataInfo(null); // Reset uploaded data info on new file upload

    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
        });

        if (sheet.length > 1) {
          setHeaders(sheet[0].filter((header) => header)); // Filter non-blank headers
          setFileData(sheet.slice(1)); // Store all rows (excluding headers)
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleMappingChange = (header, field) => {
    setMapping((prev) => ({ ...prev, [header]: field }));
  };

  // submit the data to API =====================================
  const handleSubmit = async () => {
    setIsLoading(true); // Show loading icon
    setCompanyCreated(0); // Reset counts
    setCompanyUpdated(0);
    setAccountCreated(0);
    setAccountUpdated(0);

    // Validation: Check if all required fields are mapped
    const unmappedRequiredFields = Object.keys(userModelFields).filter(
      (field) => userModelFields[field].required && !mapping[field]
    );

    if (unmappedRequiredFields.length > 0) {
      setInvalidFields(unmappedRequiredFields);
      setValidationError(
        t(
          `The following required fields are not mapped: ${unmappedRequiredFields
            .map((field) => userModelFields[field].label)
            .join(", ")}`
        )
      );
      setIsLoading(false); // Disable loading icon
      return;
    }

    setInvalidFields([]);
    setValidationError("");

    // send the data to API ----------------------------
    if (fileData && Object.keys(mapping).length) {
      const batchSize = 50; // Define batch size
      const totalBatches = Math.ceil(fileData.length / batchSize); // Calculate total batches

      for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
        const batchData = fileData.slice(
          batchIndex * batchSize,
          (batchIndex + 1) * batchSize
        ); // Extract batch data

        const payload = {
          mapping,
          header: headers,
          filedata: batchData, // Send batch data
          role: selectedRole.value, // Include selected role in payload
        };

        console.log(
          `Sending batch ${batchIndex + 1} of ${totalBatches}`,
          payload
        ); // Log the payload

        try {
          // if selectedRole is user or educator, save as user, else save as company and contact
          let requestUrl =
            selectedRole.value === "user" || selectedRole.value === "educator"
              ? url.API_BASEURL + url.API_CSV_UPLOAD_USER + `?token=${token}`
              : url.API_BASEURL +
                url.API_CSV_UPLOAD_COMPANY +
                `?token=${token}`;

          console.log("Request URL:", requestUrl); // Log the request URL

          const response = await postData(requestUrl, payload);

          console.log("Response for batch", batchIndex + 1, response); // Log the response

          if (response.status === true) {
            // Update counts based on response
            setCompanyCreated(
              (prev) => prev + (response.data.companycreated || 0)
            );
            setCompanyUpdated(
              (prev) => prev + (response.data.companyupdated || 0)
            );
            setAccountCreated(
              (prev) => prev + (response.data.contactcreated || 0)
            );
            setAccountUpdated(
              (prev) => prev + (response.data.contactupdated || 0)
            );
          } else {
            console.error(`Batch ${batchIndex + 1} failed`, response);
            setValidationError(t("Error occurred while uploading batch data."));
            break; // Stop processing further batches if an error occurs
          }
        } catch (error) {
          console.error(
            `Error during API call for batch ${batchIndex + 1}:`,
            error
          );
          setValidationError(t("Error occurred while uploading batch data."));
          break; // Stop processing further batches if an error occurs
        }
      }

      setIsLoading(false); // Disable loading icon
      handleCloseModal(); // Reset modal after all batches are processed
    }
  };

  const handleCloseModal = () => {
    setFileData(null);
    setHeaders([]);
    setMapping({});
    setValidationError("");
    setInvalidFields([]);
    setSelectedRole(null);
    setUserModelFields({});
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear file input value
    }
    setUploadedCompanyDataInfo(null); // Reset uploaded data info
  };

  return (
    <div
      className="modal modal-xl"
      id="csvUserUploadModal"
      tabIndex="-1"
      aria-labelledby="csvUserUploadModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 rounded-0">
          <div className="modal-header border-0">
            <h3 className="text-secondary mb-0" id="csvUserUploadModalLabel">
              <span className="d-block">{t("Upload CSV/XLS File")}</span>
            </h3>
            <button
              type="button"
              className="btn-close p-2 bg-white shadow-none shadow-sm m-0 ms-auto"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleCloseModal} // Reset all states on close
            ></button>
          </div>
          <div className="modal-body text-center p-5 pt-0">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group mb-4">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="roleSelect" style={{ textAlign: "left" }}>
                      {t("Select Upload Type")} *
                    </label>
                    <Select
                      options={roleOptions}
                      value={selectedRole}
                      onChange={handleRoleChange}
                      className="mb-3"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="fileUpload" style={{ textAlign: "left" }}>
                      {t("Choose a CSV/XLS file")} *
                    </label>
                    <input
                      type="file"
                      accept=".csv, .xls, .xlsx"
                      ref={fileInputRef}
                      className="form-control border-gray mb-3"
                      onChange={handleFileUpload}
                    />
                  </div>
                </div>
                {fileData && (
                  <div className="mb-3">
                    <span className="text-secondary">
                      {t("Total rows of data to be added")}: {fileData.length}
                    </span>
                  </div>
                )}
                {headers.length > 0 && (
                  <div>
                    <h4>{t("Map columns with application fields")}</h4>
                    <div className="d-flex justify-content-between mb-2 text-center">
                      <span className="fw-bold" style={{ width: "30%" }}>
                        {t("App Data")}
                      </span>
                      <span className="fw-bold" style={{ width: "30%" }}>
                        {t("File Header")}
                      </span>
                      <span className="fw-bold" style={{ width: "30%" }}>
                        {t("File Value")}
                      </span>
                    </div>
                    {Object.keys(userModelFields).map((field, index) => (
                      <div
                        key={index}
                        className={`d-flex align-items-center mb-3 ${
                          mapping[field] ? "bg-info bg-gradient" : ""
                        }`}
                        style={{
                          border: invalidFields.includes(field)
                            ? "1px solid red"
                            : "none",
                        }}
                      >
                        {/* Field Label */}
                        <label className="me-3" style={{ width: "30%" }}>
                          {userModelFields[field].label}
                          {userModelFields[field].required && (
                            <span className="text-danger"> *</span>
                          )}
                        </label>
                        {/* Header Mapping */}
                        <Select
                          options={headers.map((header) => ({
                            value: header,
                            label: header,
                          }))}
                          onChange={(selected) =>
                            handleMappingChange(field, selected?.value || null)
                          }
                          isClearable
                          className="flex-grow-1 me-3"
                          style={{ width: "30%" }}
                        />
                        {/* File Value */}
                        <span style={{ width: "30%" }}>
                          {(mapping[field] &&
                            fileData &&
                            fileData[0][headers.indexOf(mapping[field])]) ||
                            ""}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
                {validationError && (
                  <div className="text-danger fw-bold mt-3">
                    {validationError}
                  </div>
                )}
                {Object.keys(mapping).length > 0 && (
                  <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={isLoading} // Disable button while loading
                    >
                      {isLoading ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        t("Submit")
                      )}
                    </button>
                  </div>
                )}
                {(companyCreated > 0 ||
                  companyUpdated > 0 ||
                  accountCreated > 0 ||
                  accountUpdated > 0) && (
                  <div className="mt-3">
                    <h5>{t("Uploaded Data Info (Batch Progress)")}</h5>
                    <pre>
                      {t("Company Created")}: {companyCreated}
                    </pre>
                    <pre>
                      {t("Company Updated")}: {companyUpdated}
                    </pre>
                    <pre>
                      {t("Account Created")}: {accountCreated}
                    </pre>
                    <pre>
                      {t("Account Updated")}: {accountUpdated}
                    </pre>
                  </div>
                )}

                {uploadedCompanyDataInfo && (
                  <div className="mt-3">
                    <h5>{t("Uploaded Data Info")}</h5>
                    <pre>
                      {t("Company Created")} :{" "}
                      {uploadedCompanyDataInfo.companycreated
                        ? uploadedCompanyDataInfo.companycreated
                        : 0}
                    </pre>
                    <pre>
                      {t("Pre Existing Company")} :{" "}
                      {uploadedCompanyDataInfo.companyupdated
                        ? uploadedCompanyDataInfo.companyupdated
                        : 0}
                    </pre>
                    <pre>
                      {t("Contact Created")} :{" "}
                      {uploadedCompanyDataInfo.contactcreated
                        ? uploadedCompanyDataInfo.contactcreated
                        : 0}
                    </pre>
                    <pre>
                      {t("Pre existing contact")} :{" "}
                      {uploadedCompanyDataInfo.contactupdated
                        ? uploadedCompanyDataInfo.contactupdated
                        : 0}
                    </pre>

                    <label>
                      ** {t("Please refresh the page to see the result")}
                    </label>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CsvUploadModal;
